import React, { useState } from 'react';

interface GuessPredictionsSectionProps {
  invitationId: string | null;
  isLive: boolean;
  language: 'en' | 'mr';
  onPredictionAdded: () => void;
  totalPredictions: number;
}

export const GuessPredictionsSection: React.FC<GuessPredictionsSectionProps> = ({
  language,
  onPredictionAdded,
  totalPredictions,
}) => {
  const [name, setName] = useState('');
  const [birthDate, setBirthDate] = useState('');
  const [weight, setWeight] = useState('');
  const [gender, setGender] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) return;
    setName('');
    setBirthDate('');
    setWeight('');
    setGender('');
    onPredictionAdded();
  };

  return (
    <section className="relative py-24 px-4 bg-gradient-to-b from-yellow-50 to-pink-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-center text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-pink-500 mb-4">
          {language === 'mr' ? '🎯 अनुमान खेळ' : '🎯 Baby Predictions Game'}
        </h2>
        <p className="text-center text-gray-600 mb-12">
          {language === 'mr' ? `${totalPredictions} अनुमान` : `${totalPredictions} predictions so far`}
        </p>

        <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-lg p-8 border-4 border-yellow-300">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">
                {language === 'mr' ? 'तुमचे नाव' : 'Your Name'} *
              </label>
              <input
                type="text"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full border-2 border-yellow-300 rounded-lg px-4 py-2 font-semibold"
              />
            </div>

            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">
                {language === 'mr' ? 'जन्म तारीख' : 'Birth Date'}
              </label>
              <input
                type="date"
                value={birthDate}
                onChange={(e) => setBirthDate(e.target.value)}
                className="w-full border-2 border-yellow-300 rounded-lg px-4 py-2 font-semibold"
              />
            </div>

            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">
                {language === 'mr' ? 'वजन (पाउंड)' : 'Weight (lbs)'}
              </label>
              <input
                type="number"
                value={weight}
                onChange={(e) => setWeight(e.target.value)}
                placeholder="7.5"
                className="w-full border-2 border-yellow-300 rounded-lg px-4 py-2 font-semibold"
              />
            </div>

            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">
                {language === 'mr' ? 'लिंग' : 'Gender'}
              </label>
              <select
                value={gender}
                onChange={(e) => setGender(e.target.value)}
                className="w-full border-2 border-yellow-300 rounded-lg px-4 py-2 font-semibold"
              >
                <option value="">{language === 'mr' ? 'निवडा' : 'Select'}</option>
                <option value="boy">👦 {language === 'mr' ? 'मुलगा' : 'Boy'}</option>
                <option value="girl">👧 {language === 'mr' ? 'मुलगी' : 'Girl'}</option>
                <option value="surprise">🎉 {language === 'mr' ? 'आश्चर्य' : 'Surprise'}</option>
              </select>
            </div>
          </div>

          <button
            type="submit"
            className="w-full mt-6 bg-gradient-to-r from-yellow-400 to-pink-400 text-white font-bold py-3 rounded-lg hover:shadow-lg transition-all"
          >
            {language === 'mr' ? '🎯 अनुमान सबमिट करा' : '🎯 Submit Prediction'}
          </button>
        </form>
      </div>
    </section>
  );
};
